



































import { Vue, Component, Prop, Ref } from 'vue-property-decorator'
import ModalDialog from 'components/modals/Dialog.vue'
import { PersonPublicProfile, ItemShareRole } from 'src/graphql/types'

@Component({
  components: {
    ModalDialog
  }
})
export default class ItemTeamSelectRole extends Vue {
  ItemShareRole = ItemShareRole

  @Prop()
  readonly person!: PersonPublicProfile | null

  @Ref()
  readonly dialog!: ModalDialog

  show () {
    this.dialog.show()
  }

  select (role: ItemShareRole | null) {
    this.dialog.hide()
    this.$emit('select', role)
  }
}
